import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  ButtonToolbar,
  Row,
  Col,
} from "reactstrap";
// import axios from 'axios';
import { Form, Field } from "react-final-form";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ThemeProps, RTLProps } from "../../../shared/prop-types/ReducerProps";
import renderCheckBoxField from "@/shared/components/form/CheckBox";
import renderSelectField from "@/shared/components/form/Select";
import axios from "axios";
import getStatesByCountry from "@/service/getStatesByCountry";
import { labelizeNamedData } from "@/shared/helpers";

const CopyProgramModal = ({ isOpen, setOpen, toggle, program, theme, rtl }) => {
  const [loading, setLoading] = useState(false);
  const [domainOptions, setDomainOptions] = useState(null);
  const [defaultDomain, setDefaultDomain] = useState(null);
  const [states, setStates] = useState(null);
  const [initialValues, setInitialValues] = React.useState({
    use_same_address: true, copy_manager_report_setting:true
  });

  useEffect(() => {
    const url = `/organization/${program.organization_id}/program/${program.id}`;
    axios
      .get(url)
      .then((res) => {
        if (res.status === 200) {
          const programData = res?.data;
          if (!domainOptions) {
            let options = [];
            if (
              !defaultDomain &&
              res.data?.default_domain &&
              res.data?.default_domain.length > 0
            ) {
              setDefaultDomain({
                label: res.data?.default_domain[0].name,
                value: res.data?.default_domain[0].id,
              });
            }
            res.data?.domains.map((domain, i) => {
              options.push({ label: domain.name, value: "" + domain.id });
            });
            setDomainOptions(options);
          }

          setInitialValues({
            name: `Copy of ${programData?.name}` || "",
            use_same_address: true,
            address: programData?.address,
            external_id: programData?.external_id,
            copy_manager_report_setting: true,
            // Add other expected fields
          });
        }
      })
      .catch((error) => {
        // setErrors(error.response.data);
        // setLoading(false)
      });

    if (program.organization_id) {
      getStatesByCountry(223).then((result) => {
        setStates(labelizeNamedData(result));
      });
    }
  }, [program]);

  const onChangeDefaultDomain = (value) => {
    setDefaultDomain(value);
  };

  const onSubmitCopyForm = (values) => {
    setLoading(true);
    const data = {
      source_program_id: program.id,
      name: values.name,
      create_as_sub: values?.create_as_sub,
      copy_manager_report_setting: values?.copy_manager_report_setting,
      copy_upload_content: values?.copy_upload_content,
      copy_event_template: values?.copy_event_template,
      copy_program_template: values?.copy_program_template,
      add_program_manager: values?.add_program_manager,
      external_id: values.external_id,
      default_domain: values?.default_domain?.value,
      use_same_address: values?.use_same_address,
    };
    if (!data?.use_same_address) {
      data.address = {
        ...values?.address,
        ...{ state_id: values?.address?.state_id?.value },
      };
    }

    axios
      .post(
        `/organization/${program.organization_id}/program/${program.id}/clone`,
        data
      )
      .then((res) => {
        if (res.status == 200) {
          setLoading(false);
          window.location = "/program?message=Program copied successfully!";
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const Condition = ({ when, is, children }) => (
    <Field name={when} subscription={{ value: true }}>
      {({ input: { value } }) => (value === is ? children : null)}
    </Field>
  );

  const validate = (values) => {
    let errors = {};
    if (!values.name) {
      errors.name = "Program name is required";
    }
    return errors;
  };

  if (!program) return "Loading...";

  return (
    <Modal
      className={`modal-program ${theme.className} ${rtl.direction}-support`}
      isOpen={isOpen}
      toggle={toggle}
    >
      <ModalHeader>
        <h3 style={{ "font-weight": 500 }}>Copy Program</h3>
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={onSubmitCopyForm}
          validate={validate}
          initialValues={initialValues}
        >
          {({ handleSubmit, form, submitting, pristine, values }) => (
            <form className="form" onSubmit={handleSubmit}>
              <Field name="name">
                {({ input, meta }) => (
                  <div className="form__form-group">
                    <span className="form__form-group-label">Program name</span>
                    <div className="form__form-group-field">
                      <div className="form__form-group-row">
                        <input
                          type="text"
                          {...input}
                          placeholder="Program name"
                        />
                        {meta.touched && meta.error && (
                          <span className="form__form-group-error">
                            {meta.error}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Field>

              <Field
                name="create_as_sub"
                type="checkbox"
                component={renderCheckBoxField}
                label={`Create as subprogram under "${program.name}"`}
              />

              <Field name="external_id">
                {({ input, meta }) => (
                  <div className="form__form-group">
                    <span className="form__form-group-label">External ID</span>
                    <div className="form__form-group-field">
                      <div className="form__form-group-row">
                        <input
                          type="text"
                          {...input}
                          placeholder="External ID"
                        />
                        {meta.touched && meta.error && (
                          <span className="form__form-group-error">
                            {meta.error}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Field>

              <div className="form__form-group">
                <span className="form__form-group-label">Default Domain</span>
                <div className="form__form-group-field">
                  <Field
                    name="default_domain"
                    options={domainOptions}
                    initialValue={defaultDomain?.value}
                    component={renderSelectField}
                    parse={(value) => {
                      onChangeDefaultDomain(value);
                      return value;
                    }}
                  />
                </div>
              </div>

              <div className="form__form-group mt-2">
                <div className="form__form-group-field">
                  <Field
                    name="add_program_manager"
                    type="checkbox"
                    component={renderCheckBoxField}
                    label={"Add this program`s Managers to new program"}
                  />
                </div>
              </div>
            
              <div className="form__form-group ">
                <div className="form__form-group-field">
                  <Field
                    name="copy_manager_report_setting"
                    type="checkbox"
                    component={renderCheckBoxField}
                    label={"Copy manager report settings"}
                  />
                </div>
              </div>
            
              <div className="form__form-group ">
                <div className="form__form-group-field">
                  <Field
                    name="copy_upload_content"
                    type="checkbox"
                    component={renderCheckBoxField}
                    label={"Copy upload content"}
                  />
                </div>
              </div>
              <h5 className="thick size16 mb-2 mt-2">Template Settings</h5>

              {/* <div className="form__form-group ">
                  <div className="form__form-group-field">
                    <Field
                      name="clone_email_template"
                      type="checkbox"
                      component={renderCheckBoxField}
                      label={"Clone Email Templates"}
                    />
                  </div>
                </div> */}

              <div className="form__form-group ">
                <div className="form__form-group-field">
                  <Field
                    name="copy_event_template"
                    type="checkbox"
                    component={renderCheckBoxField}
                    label={"Copy Event Templates from this program"}
                  />
                </div>
              </div>
              <div className="form__form-group ">
                <div className="form__form-group-field">
                  <Field
                    name="copy_program_template"
                    type="checkbox"
                    component={renderCheckBoxField}
                    label={"Copy Program Templates from this program"}
                  />
                </div>
              </div>

              <h5 className="thick size16 mb-2 mt-2">Address Settings</h5>
              <div className="form__form-group mt-2">
                <div className="form__form-group-field">
                  <Field
                    name="use_same_address"
                    type="checkbox"
                    component={renderCheckBoxField}
                    label={`Use same address as that of ${
                      values?.source_program?.label || " "
                    } program`}
                  />
                </div>
              </div>
              <Condition when="use_same_address" is={false}>
                <Row className="w100">
                  <Col md="6" lg="6" xl="6">
                    <Field name="address.address">
                      {({ input, meta }) => (
                        <div className="form__form-group">
                          <span className="form__form-group-label">
                            Address
                          </span>
                          <div className="form__form-group-field">
                            <div className="form__form-group-row">
                              <input
                                type="text"
                                {...input}
                                placeholder="Address"
                              />
                              {meta.touched && meta.error && (
                                <span className="form__form-group-error">
                                  {meta.error}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </Field>
                  </Col>
                  <Col md="6" lg="6" xl="6">
                    <Field name="address.address_ext">
                      {({ input, meta }) => (
                        <div className="form__form-group">
                          <span className="form__form-group-label">
                            Address line 2
                          </span>
                          <div className="form__form-group-field">
                            <div className="form__form-group-row">
                              <input
                                type="text"
                                {...input}
                                placeholder="Address line 2"
                              />
                              {meta.touched && meta.error && (
                                <span className="form__form-group-error">
                                  {meta.error}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="w100">
                  <Col md="6" lg="4" xl="4">
                    <Field name="address.city">
                      {({ input, meta }) => (
                        <div className="form__form-group">
                          <span className="form__form-group-label">City</span>
                          <div className="form__form-group-field">
                            <div className="form__form-group-row">
                              <input
                                type="text"
                                {...input}
                                placeholder="City"
                              />
                              {meta.touched && meta.error && (
                                <span className="form__form-group-error">
                                  {meta.error}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </Field>
                  </Col>
                  <Col md="6" lg="4" xl="4">
                    <Field name="address.zip">
                      {({ input, meta }) => (
                        <div className="form__form-group">
                          <span className="form__form-group-label">Zip</span>
                          <div className="form__form-group-field">
                            <div className="form__form-group-row">
                              <input type="text" {...input} placeholder="Zip" />
                              {meta.touched && meta.error && (
                                <span className="form__form-group-error">
                                  {meta.error}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </Field>
                  </Col>
                  <Col md="6" lg="4" xl="4">
                    <div className="form__form-group">
                      <span className="form__form-group-label">State</span>
                      <div className="form__form-group-field">
                        <Field
                          name="address.state_id"
                          component={renderSelectField}
                          options={states}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Condition>

              <ButtonToolbar className="modal__footer mt-4 flex justify-content-right w100">
                <Button
                  outline
                  color="primary"
                  className="mr-3"
                  onClick={toggle}
                >
                  Cancel
                </Button>{" "}
                <Button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary"
                  color="#ffffff"
                >
                  Confirm
                </Button>
              </ButtonToolbar>
            </form>
          )}
        </Form>
      </ModalBody>
    </Modal>
  );
};

CopyProgramModal.propTypes = {
  theme: ThemeProps.isRequired,
  rtl: RTLProps.isRequired,
};

export default withRouter(
  connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
  }))(CopyProgramModal)
);

// export default CopyProgramModal
